import { makeGenericActionCreator, makeActionCreator } from "../utils/reduxUtils";

export const RESET_CHANGE_ADDRESS_STATE = "RESET_CHANGE_ADDRESS_STATE";
export const resetChangeAddressState = makeActionCreator(RESET_CHANGE_ADDRESS_STATE);

type allowedChangeAddressFields = "isChangeAddressSuccess" | "isChangeAddressFailure";
export const SET_CHANGE_ADDRESS_FIELD = "SET_CHANGE_ADDRESS_FIELD";
export const setChangeAddressField = makeGenericActionCreator<allowedChangeAddressFields>(SET_CHANGE_ADDRESS_FIELD);
